import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: block;
  background: ${({ theme }) => theme.colors?.gray?.[100] || '#f3f3f3'};
`;

const Skeleton = styled.div`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background-image: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.03) 0%,
    rgba(0, 0, 0, 0.08) 20%,
    rgba(0, 0, 0, 0.03) 40%,
    rgba(0, 0, 0, 0.03) 100%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity 0.25s ease-in-out;
`;

const LazyImage = ({ className, style, ...imgProps }) => {
  const [loaded, setLoaded] = useState(false);

  const handleDone = () => {
    setLoaded(true);
    if (typeof imgProps.onLoad === 'function') imgProps.onLoad();
  };

  const handleError = (e) => {
    setLoaded(true);
    if (typeof imgProps.onError === 'function') imgProps.onError(e);
  };

  return (
    <Wrapper className={className} style={style}>
      {!loaded && <Skeleton aria-hidden="true" />}
      <Img
        {...imgProps}
        loading={imgProps.loading || 'lazy'}
        decoding={imgProps.decoding || 'async'}
        onLoad={handleDone}
        onError={handleError}
        style={{ opacity: loaded ? 1 : 0 }}
      />
    </Wrapper>
  );
};

export default LazyImage;
